//write interface for translations
export interface Translations {
	[key: string]: TranslationObject;
}

export interface TranslationObject {
	allAssetsText: string;
	assetsFilter: string;
}

export const translations: Translations = {
	de: {
		allAssetsText: "Alle Assets",
		assetsFilter: "Assets nach Name oder ID filtern",
	},
	zh: {
		allAssetsText: "所有资产",
		assetsFilter: "按名称或 ID 筛选资产",
	},
	en: {
		allAssetsText: "All Assets",
		assetsFilter: "Filter assets by name or ID",
	},
	fr: {
		allAssetsText: "Tous les actifs",
		assetsFilter: "Filtrer les actifs par nom ou ID",
	},
	it: {
		allAssetsText: "Tutti gli asset",
		assetsFilter: "Filtra gli asset per nome o ID",
	},
	ko: {
		allAssetsText: "모든 자산",
		assetsFilter: "이름 또는 ID로 자산 필터링",
	},
	nl: {
		allAssetsText: "Alle activa",
		assetsFilter: "Assets filteren op naam of ID",
	},
	pl: {
		allAssetsText: "Wszystkie zasoby",
		assetsFilter: "Filtruj zasoby według nazwy lub ID",
	},
	es: {
		allAssetsText: "Todos los activos",
		assetsFilter: "Filtrar activos por nombre o ID",
	},
	cs: {
		allAssetsText: "Všechny prostředky",
		assetsFilter: "Filtrovat aktiva podle názvu nebo ID",
	},
	hu: {
		allAssetsText: "Minden eszköz",
		assetsFilter: "Eszközök szűrése név vagy azonosító alapján",
	},
	zh_TW: {
		allAssetsText: "所有資產",
		assetsFilter: "按名稱或 ID 篩選資產",
	},
	ja: {
		allAssetsText: "すべての資産",
		assetsFilter: "名前またはIDで資産をフィルタリングする",
	},
	pt: {
		allAssetsText: "Todos os ativos",
		assetsFilter: "Filtrar ativos por nome ou ID",
	},
};
